import { HttpClient } from '@angular/common/http';
import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { RolesTableComponent } from 'src/app/services/crud-table/tables/buyer/roles-table.component';
import { CREATE_ROLE_MODAL_STYLE } from '../../../constants';

@Component({
	selector: 'app-roles',
	templateUrl: './roles.component.html',
	styleUrls: ['./roles.component.scss']
})

export class RolesComponent extends RolesTableComponent implements OnInit, OnDestroy {

	listOfCurrentPageData: Array<object> = [];
	checked: boolean = false;
	setOfCheckedId = new Set<number>();
	indeterminate = false;
	columnWidth = '300px';
	createRoleForm: FormGroup;
	createRoleModalVisible: boolean = false;
	createRoleModalStyle: object = CREATE_ROLE_MODAL_STYLE;

	constructor(
		private formBuilder: FormBuilder,
		@Inject(HttpClient) http
	) {
		super(http);
	}

	ngOnInit(): void {
		this.createRoleForm = this.formBuilder.group({
			roleName: ['', [Validators.required]]
		});
	}

	panels = [
		{
			id: 1,
			active: true,
			indeterminate: false,
			allChecked: false,
			name: 'Domain Name (eg. Tender) 1',
			childPanel: [
				{
					active: false,
					name: 'Tender - Attachments - Read',
					checked: false
				},
				{
					active: false,
					name: 'Tender - Attachments - writeMy',
					checked: false
				},
				{
					active: false,
					name: 'Tender - Attachments - write',
					checked: false
				}
			]
		},
		{
			id: 2,
			active: false,
			allChecked: false,
			indeterminate: false,
			name: 'Domain Name (eg. Tender) 2',
			childPanel: [
				{
					active: false,
					name: 'Tender - Attachments - Read 2-1',
					checked: false
				},
				{
					active: false,
					name: 'Tender - Attachments - writeMy',
					checked: false
				},
				{
					active: false,
					name: 'Tender - Attachments - write',
					checked: false
				}
			]
		},
		{
			id: 3,
			active: false,
			allChecked: false,
			indeterminate: false,
			name: 'Domain Name (eg. Tender) 3',
			childPanel: [
				{
					active: false,
					name: 'Tender - Attachments - Read',
					checked: false
				},
				{
					active: false,
					name: 'Tender - Attachments - writeMy',
					checked: false
				},
				{
					active: false,
					name: 'Tender - Attachments - write',
					checked: false
				}
			]
		}
	];

	listOfData = [
		{
			id: 1,
			name: 'Administration',
			systemRole: 'Yes'
		},
		{
			id: 2,
			name: 'Buyer',
			systemRole: 'Yes'
		},
		{
			id: 3,
			name: 'Supplier',
			systemRole: 'No'
		}
	];

	listOfColumn = [
		{
			title: 'Roles',
			compare: null,
			sortOrder: null,
			sortFn: (a: object, b: object) => a['name'].localeCompare(b['name']),
			sortDirections: ['ascend', 'descend', null],
			width: '60%'
		},
		{
			title: 'System Role',
			width: '15%'
		},
		{
			title: 'Actions',
			width: '10%'
		}
	];

	/**
	 * Handle all row selection
	 * @param value : boolean value to check mark all rows
	 */
	onAllChecked(value: boolean): void {
		const data = this.grouping.selectAllRows();
		this.setOfCheckedId = data.selectedRowIds;
		this.refreshCheckedStatus();
	}

	/**
	 * Handle set check status
	 * @param id : unique key of data set
	 * @param checked: value for updating set
	 */
	updateCheckedSet(id: number, checked: boolean): void {
		this.grouping.selectRow(id);
		this.refreshCheckedStatus();
	}

	/**
	 * Handle refresh checked status.
	 */
	refreshCheckedStatus(): void {
		this.checked = this.grouping.checkAreAllRowsSelected();
		const allUnchecked = this.grouping.getSelectedRowsCount();
		if(allUnchecked === 0) {
			this.checked = false;
			this.setOfCheckedId = new Set<number>();
		}
		this.indeterminate = this.grouping.getSelectedRowsCount() > 0 && !this.checked;
	}

	/**
	 * Handle current page change event.
	 * @param $event : change event
	 */
	onCurrentPageDataChange($event): void {
		this.listOfCurrentPageData = $event;
		this.refreshCheckedStatus();
	}

	/**
	 * Handle each row selection
	 * @param id : unique key of data set
	 * @param checked: checked value (true/false)
	 */
	onItemChecked(id: number, checked: boolean): void {
		this.updateCheckedSet(id, checked);
		this.refreshCheckedStatus();
	}

	/**
	 * Handle search roles
	 * @param data : input data
	 */
	onChange(data: string): void {
		const dataObject = {
			searchTerm: data.trim()
		};

		this.findRoles(dataObject).subscribe(response => {
			//console.log('roles', response);
		});
	}

	/**
	 * Handle user invite form submission.
	 * @param formValues : values of all fields of user invite form
	 */
	handleOk(formValues: object): void {
		this.createRoleModalVisible = false;
		this.createRoleForm.reset();
	}

	/**
	 * Handle user invite form close.
	 */
	handleCancel(formValues: object): void {
		this.createRoleModalVisible = false;
		this.createRoleForm.reset();
	}

	/**
	 * Handle create role popup modal opening
	*/
	displayCreateRoleModal(): void {
		this.createRoleModalVisible = true;
	}

	/**
	 * Delete all selected roles
	 */
	deleteAllSelectedRoles(): void {
		const selectedItemIds = this.grouping.getSelectedRows();
		// const sb = this.deleteRoles(selectedItemIds).subscribe();
		// this.subscriptions.push(sb);
	}

	ngOnDestroy(): void {
		this.subscriptions.forEach(sb => sb.unsubscribe());
	}
}
